import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddProductVersionButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/product_versions/create?product=${record['@id']}`}
    label="Add a product version"
    title="Add a product version"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddProductVersionButton);
